/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reason_For_ReleaseInputs */

const en_reason_for_release = /** @type {(inputs: Reason_For_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason for release`)
};

const es_reason_for_release = /** @type {(inputs: Reason_For_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo de liberacion`)
};

/**
* | output |
* | --- |
* | "Reason for release" |
*
* @param {Reason_For_ReleaseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reason_for_release = /** @type {((inputs?: Reason_For_ReleaseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reason_For_ReleaseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reason_for_release(inputs)
	return es_reason_for_release(inputs)
});